import StorageService from '../../storage-service';

const authReducer = (state = {}, action) => {
  switch (action.type) {
  case 'CHECK_AUTH':
    if (action.error) return state;
    return {
      ...state,
      authenticated: action.data,
    };

  case 'LOGIN':
  case 'SIGN_UP':
    StorageService.set('api_token', action.data.api_token);
    if (action.error) return state;
    return {
      ...state,
      authenticated: true,
    };

  case 'CONFIRM_MOBILE_OTP':
    StorageService.set('api_token', action.data.token);
    if (action.error) return state;
    return {
      ...state,
      authenticated: true,
    };

  case 'LOGIN_WITH_PHONE_NUMBER':
  case 'SIGN_UP_WITH_PHONE_NUMBER':
    if (action.error) return state;
    return {
      ...state,
      authenticated: false,
    };

  case 'LOGOUT':
    return {
      ...state,
      authenticated: false,
    };

  default:
    return state;
  }
};

export default authReducer;
